
angular.module("people_import", [])

    .controller("PeopleImportCtrl", ['$state', '$timeout', '$stateParams', 'Restangular', '$scope', '$rootScope', '$http', '$filter', 'modalService', '$uibModal', 'gridService', 
        function ($state, $timeout, $stateParams, Restangular, $scope, $rootScope, $http, $filter, modalService, $uibModal, gridService) {

            $scope.genders = [{ id: 'M', name: $filter("translate")('persons.gender_male') }, { id: 'F', name: $filter("translate")('persons.gender_female') }, { id: 'N', name: $filter("translate")('persons.gender_neutral') }];
            $scope.totalPeople = 0;
            $scope.treatments = [];

            $scope.check = { dataFullyLoaded: false };

            Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {

                $scope.military_groups_enabled = results.military_groups_enabled;
                let militaryPositionColumn = $scope.gridPeopleImport.columnDefs.filter((m) => m.name == "Position_militar");
                militaryPositionColumn.pop().visible = results.military_groups_enabled;

            });

            $scope.actions = function (rowEntity) {

                if (rowEntity.Duplicate) {
                    return [
                        { id: 'import', name: "Importar" },
                        { id: 'ignore', name: "Ignorar" },
                        { id: 'invite', name: "Sólo invitar" },
                        { id: 'add_position', name: "Agregar cargo" },
                    ];
                } else {
                    return [
                        { id: 'import', name: "Importar" },
                        { id: 'ignore', name: "Ignorar" },
                    ];
                }

            };

            Restangular.all('PersonsTreatments').getList().then(function (data) {
                angular.forEach(data, function (value, key) {
                    $scope.treatments.push({ id: value.name, name: value.name });
                });
            });

            $scope.selectedRows = [];

            $scope.rowFormatterAuthority = function (row) {
                return row.entity.Duplicate != null &&  row.entity.PersonType == 'authority' && !row.entity.matched_guest_id;
            };

            $scope.rowFormatterAnonymous = function (row) {
                return row.entity.Duplicate != null && row.entity.PersonType == 'anonymous' && !row.entity.matched_guest_id;
            };

            $scope.rowTitleParser = function (row) {

                if (row.entity.Duplicate != null && row.entity.matched_guest_id) {

                    return $filter("translate")('persons.imported_invited_duplicates');

                } else if (row.entity.Duplicate != null && row.entity.PersonType == 'authority') {

                    return $filter("translate")('persons.imported_database_duplicate_authority');

                } else if (row.entity.Duplicate != null && row.entity.PersonType == 'anonymous') {

                    return $filter("translate")('persons.imported_database_duplicate_anonymous');

                } else {

                    return "";

                };

            };

            $scope.gridPeopleImport = {
                // enableGridMenu: true,
                paginationPageSizes: 200,
                paginationPageSize: 200,
                enableScrollbars: false,
                enableRowSelection: true,
                enableSelectAll: true,
                onRegisterApi: function (gridApi) {

                    $scope.gridApi = gridApi;
                    callbackFunctionGridResize();
                    this.gridApi = gridApi;
                    this.gridApi.pagination.on.paginationChanged($scope, this.gridApi.selection.clearSelectedRows);
                    this.gridApi.pagination.on.paginationChanged($scope, callbackFunctionGridResize);

                },
                columnDefs: [
                    {
                        name: 'Name', displayName: $filter('translate')('general.name'), minWidth: 150,
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui - grid - cell - contents">' +
                            '<div><span ng-if="row.entity.Duplicate != null && !row.entity.matched_guest_id" class="fa fa-triangle-exclamation fa-lg" ng-style=\"{ color:  grid.appScope.rowFormatterAuthority(row) ? \'#bb1010;\' : \'#0B6623;\'}\" title="Encontrada coincidencia"></span>'
                            +'<span ng-if="row.entity.matched_guest_id" class="fa fa-triangle-exclamation fa-lg" style="color: #102c54;" title="Persona ya invitada"></span>'
                        +'{{ row.entity.Name }}</div > '
                    },
                    {
                        name: 'Surname', displayName: $filter('translate')('persons.surname'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    {
                        name: 'Lastname', displayName: $filter('translate')('persons.lastname'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    /*{
                        name: 'Gender', displayName: $filter('translate')('persons.gender'), editableCellTemplate: 'ui-grid/dropdownEditor', 
                        cellFilter: 'mapGender', editDropdownValueLabel: 'name', editDropdownOptionsArray: $scope.genders, width: 60,
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col) | mapGender}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col) | mapGender}}</span>' +
                            '</div>'
                    },*/
                    {
                        name: 'Accreditation', displayName: $filter('translate')('events.guests.accreditation'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'  
                    },
                    {
                        name: 'Person_tag', displayName: $filter('translate')('persons.tags'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    {
                        name: 'Email', displayName: $filter('translate')('persons.mail'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    {
                        name: 'NumIdentification', displayName: 'DNI /NIE',
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'                        /* $filter('translate')('persons.num_identification') */
                    },
                    {
                        name: 'Position', displayName: $filter('translate')('persons.position'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    {
                        visible: false,
                        name: 'Position_militar', displayName: $filter('translate')('persons.position_militar'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                   // {
                   //     name: 'PositionTreatment', displayName: $filter('translate')('persons.treatment_position'), width: 100, editableCellTemplate: 'ui-grid/dropdownEditor',
                   //     editDropdownValueLabel: 'name', editDropdownOptionsArray: $scope.treatments
                   // },
                    {
                        name: 'Institution', displayName: $filter('translate')('persons.institution'),
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    {
                        name: 'Group1', displayName: $filter('translate')('persons.group') + " 1",
                        cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                            '<span >{{grid.getCellValue(row, col)}}</span>' +
                            '</div>'
                    },
                    {
                        name: 'Action', displayName: $filter('translate')('events.guests.actions'), width: 150, editableCellTemplate: 'ui-grid/dropdownEditor', 
                        editDropdownValueLabel: 'name', cellFilter: 'mapActionGroup', editDropdownOptionsFunction: function (rowEntity, colDef) {
                            return $scope.actions(rowEntity);
                        },
                    },
                    {
                        name: ' ',
                        exporterSuppressExport: true,
                        enableSorting: false,
                        enableHiding: false,
                        enableFiltering: false,
                        enableColumnMenu: false,
                            cellTemplate: gridService.actionTemplate([
                                {
                                    title: $filter('translate')('events.user_view'),
                                    action: 'ng-click="grid.appScope.showDuplicate(row.entity)" ng-if="row.entity.Duplicate != null"',
                                    cssIconClass: "fa fa-file"
                                },
                            ], {cssClass: "pull-right"})
                    }
                ],

                // expandableRowTemplate: 'app/common/people_import/expandable_row_people_import.html',
                rowTemplate: '<div ng-class="{ \'ui-grid-row-warning-authority\': grid.appScope.rowFormatterAuthority( row ), \'ui-grid-row-warning-anonymous\': grid.appScope.rowFormatterAnonymous( row ), \'ui-grid-row-info\': row.entity.matched_guest_id }",  title="{{grid.appScope.rowTitleParser( row )}}">' +
                    '  <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"  ui-grid-cell></div>' +
                    '</div>'
            };

            $scope.importOptions = function (people, event_id, person_type, group_id, menu_item_id) {

                $scope.event_id = event_id;
                $scope.person_type = person_type;
                $scope.group_id = group_id;
                $scope.totalPeople = people.length;
                menu_item_id ? $scope.menu_item_id = menu_item_id : $scope.menu_item_id = 1;

                /*
                    angular.forEach(people, function (row) {
                        row.subGridOptions = {
                            columnDefs: [
                                { name: 'NotesPerson', displayName: $filter('translate')('persons.notes')},
                                { name: 'NotesGuest', displayName: $filter('translate')('events.guests.guests_notes')},
                                { name: 'Email2', displayName: $filter('translate')('persons.mail') + " 2"  },
                                { name: 'Phone', displayName: $filter('translate')('persons.phone')  },
                                { name: 'Group4', displayName: $filter('translate')('persons.group') + " 4"  },
                                { name: 'Group5', displayName: $filter('translate')('persons.group') + " 5"  }
                            ],
                        data: [ row ]
                        };
                */

                people.forEach(function (person) {
                    // Asignamos el género correctamente para que aparezca bien en el listado
                    switch (person.Gender.toLowerCase()) {
                        case "m":
                        case "hombre":
                        case "male":
                        case "masculino":
                            person.Gender = "M";
                            break;
                        case "n":
                        case "neutro":
                        case "neutral":
                        case "ninguno":
                            person.Gender = "N";
                            break;

                        case "f":
                        case "mujer":
                        case "female":
                        case "femenino":
                            person.Gender = "F";
                            break;
                    }
                });

                let index = 0;

                // Lo pongo aquí para controlar que se ha cargado todo correctament en importaciones largas
                Promise.all(people.map((p) => p = { ...p, gridId: index++ })).then(function (data) {
                    $scope.gridPeopleImport.data = data;
                    $scope.check.dataFullyLoaded = true;
                    toastr.success($filter('translate')('events.importation_data_fully_loaded'));
                    callbackFunctionGridResize();
                });

                /*
                    index = 0;
                    $scope.gridPeopleImport.data = people.map((p) => p = { ...p, gridId: index++ });
                    logService.debug('He aquí los maravillosos datos de este lindo CVS')
                    logService.debug($scope.gridPeopleImport.data)
                */

            }
            
            // Función a mano para gestionar el grid
            let callbackFunctionGridResize = function () {

                let visibleRows = $scope.gridPeopleImport.data.length - ($scope.gridPeopleImport.paginationPageSize * ($scope.gridPeopleImport.paginationCurrentPage - 1));

                if (visibleRows > $scope.gridPeopleImport.paginationPageSize) visibleRows = $scope.gridPeopleImport.paginationPageSize;
                $scope.gridSize = visibleRows * 30.05 + 100;

            };         

            // Acciones masivas 
            $scope.massiveImport = function () { $scope.gridApi.selection.getSelectedRows().forEach(r => r.Action = 'import') }
            $scope.massiveInvite = function () {

                let selectedRows = $scope.gridApi.selection.getSelectedRows();
                selectedRows.forEach(function (r) {
                    if (r.Duplicate != null) {
                        r.Action = 'invite';
                    }
                });

                // Si la acción no es compatible con todas las filas, sacamos mensaje. 
                if (selectedRows.some(r => r.Duplicate == null)) {

                    modalService.message({
                        title: "Acción no compatible con todos los elementos",
                        message: "Esta acción requiere que el invitado tenga una coincidencia en la aplicación, solo se ha aplicado a los invitados pertinentes",//$filter('translate')('events.image_size_limit') + "<br>" + limit_image_width + "X" + limit_image_height,
                        onAccept: function () { }
                    });

                }
            }

            $scope.massiveIgnore = function () { $scope.gridApi.selection.getSelectedRows().forEach(r => r.Action = 'ignore') }

            $scope.massiveAddPosition = function () {

                let selectedRows = $scope.gridApi.selection.getSelectedRows();

                selectedRows.forEach(function (r) {
                    if (r.Duplicate != null) {
                        r.Action = 'add_position';
                    }
                }); 

                if (selectedRows.some(r => r.Duplicate == null)) {

                    modalService.message({
                        title: $filter('translate')('events.import_massive_action_warning'), //"Acción no compatible con todos los elementos",
                        message: $filter('translate')('events.import_massive_action_warning_message'), //"Esta acción requiere que el invitado tenga una coincidencia en la aplicación. Solo se ha aplicado a los invitados pertinentes.",//$filter('translate')('events.image_size_limit') + "<br>" + limit_image_width + "X" + limit_image_height,
                        onAccept: function () { }
                    });

                }
            }

            $scope.import = function () {

                let people = [];
                angular.forEach($scope.gridPeopleImport.data, function (row) {
                    let person: any = {};
                    angular.copy(row, person);
                    person.subGridOptions = null;
                    people.push(person);
                });

                let request = {
                    people: people,
                    person_type: $scope.person_type
                };

                Restangular.all('People').customPOST(request, "Import", {event_id: $scope.event_id, group_id: $scope.group_id}).then(function (result) {

                    if ($scope.event_id != null && $scope.event_id != 0) {

                    // GOBACKHERE
                    $state.go('events.edit.guests', { id: $scope.event_id, menu_item_id: $scope.menu_item_id });

                    } else if ($scope.group_id != null && $scope.group_id != 0) {
                        $state.go('groups.list');
                    } else if ($scope.person_type != null && $scope.person_type !== "") {
                        $state.go('persons.list', { person_type: $scope.person_type });
                    }

                }, function (error) {

                    let exceptionString = error.data.ExceptionMessage.split('/');
                    let exceptionMessage = exceptionString[0];
                    let exceptionExtraInfo = exceptionString[1];
                    let exceptionRowInfo = exceptionString[2]; 

                    modalService.message({
                        title: $filter('translate')('events.guests.invalid_csv_title_boring'),
                        message: (exceptionRowInfo ? $filter('translate')('events.guests.row') + " " + exceptionRowInfo + ": " : "") + (exceptionExtraInfo ? $filter('translate')(exceptionExtraInfo) + " ": "") + $filter('translate')(exceptionMessage),
                        onAccept: function () {
                            $state.go('events.edit.guests', { id: $scope.event_id, menu_item_id: $scope.menu_item_id });
                        },
                        onCancel: function() {
                            $state.go('events.edit.guests', { id: $scope.event_id, menu_item_id: $scope.menu_item_id });
                        }

                    });
                }

                );

            };

            $scope.cancel = function () {
                $state.go('events.edit.guests', { id: $scope.event_id, menu_item_id: $scope.menu_item_id });
            };

            $scope.showDuplicate = function (rowEntity) {
                let url = $state.href('persons.edit', { id: rowEntity.Duplicate, person_type: rowEntity.PersonType });
                window.open(url, '_blank');
            };

}])
.filter('mapGender', function() {
    let genderHash = {
        'M': 'Hombre',
        'F': 'Mujer',
        'N': 'Neutro'
    };

    return function(input) {
        if (!input){
            return '';
        } else {
            return genderHash[input];
        }
    };
})
    .filter('mapActionGroup', function () {
    let actionHash = {
        'import': 'Importar',
        'ignore': 'Ignorar',
        'invite': 'Sólo invitar',
        'add_position': 'Agregar cargo',
    };

    return function(input) {
        if (!input){
            return '';
        } else {
            return actionHash[input];
        }
    };

});
